import { render, staticRenderFns } from "./ModalReproveContract.vue?vue&type=template&id=5a795fc6&scoped=true&"
import script from "./ModalReproveContract.vue?vue&type=script&lang=ts&"
export * from "./ModalReproveContract.vue?vue&type=script&lang=ts&"
import style0 from "./ModalReproveContract.vue?vue&type=style&index=0&id=5a795fc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a795fc6",
  null
  
)

export default component.exports